<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="crewMemberTypeRatingAudits && crewMemberTypeRatingAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list [audits]="crewMemberTypeRatingAudits" (nextPage)="onNextPage()">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No AC Type Rating audits </ng-template>
</ng-template>
